<div class="wrapper">
    
    <app-sidebar [page]="9"></app-sidebar>
    
    <div class="w-100">
        <app-top-bar></app-top-bar>

        <div class="card">

            <!-- title and export -->
            <div class="header">
                
                <div class="title">
                    <app-svg class="title-svg" 
                        width="25px"
                        height="25px"
                        color="#ef182e"
                        src="assets/svg/wallet-fill.svg">
                    </app-svg>
                    <h2>E-Pins</h2>              
                </div>
        
                <button (click)="exportEpinRecord()">
                    <svg id="Layer_1" data-name="Layer 1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><defs><style>.cls-1{fill:none;}</style></defs><path class="cls-1" d="M106.8,134.48H357.4a24.52,24.52,0,1,0,0-49H106.8a24.52,24.52,0,0,0,0,49Z"/><path d="M106.8,382.36a24.52,24.52,0,0,1,0-49h70.63A169.35,169.35,0,0,1,201,258.42H106.8a24.52,24.52,0,0,1,0-49H245a170.42,170.42,0,0,1,211.52,5.29V67.15A57.66,57.66,0,0,0,398.85,9.5H65.35A57.66,57.66,0,0,0,7.69,67.15v333.5a57.66,57.66,0,0,0,57.66,57.66H219.58A169.93,169.93,0,0,1,181,382.36Zm0-296.91H357.4a24.52,24.52,0,1,1,0,49H106.8a24.52,24.52,0,0,1,0-49Z"/><path d="M456.51,250.26A144.9,144.9,0,0,0,203,333.32q-.51,6.07-.52,12.29a144.9,144.9,0,1,0,254-95.35ZM422.1,383a24.52,24.52,0,1,1-49,0V355.53l-26.82,26.83L314.58,414a24.52,24.52,0,0,1-37.23-31.67,24.84,24.84,0,0,1,2.55-3l46-46,14.27-14.27H312.79a24.52,24.52,0,1,1,0-49H422.1Z"/></svg>
                    <span>Export CSV</span>
                </button>
                
            </div>
                
            <!-- </div> -->
            <div class="filter-list">

                <!-- WEB SEARCH FILTER -->
                <app-filter-search-bar
                    *ngIf="!isMobile"
                    [searchValue] = "searchValue"
                    (updateSearchValue) = "updateSearchValue($event)"
                ></app-filter-search-bar>
                
                <!--  clear button -->
                <div class="search-n-clear">
                    <button 
                        *ngIf="!isMobile"
                        (click)="clearAllFilters()" 
                        type="button" 
                        class="btn btn-outline-primary">
                        <span>Clear</span>
                    </button>
                </div>
                
            </div>

        </div>
        
        <app-epin-table
            (updateSort)="updateSort($event)"
            [epinListData] = "epinListData"
            [message] = "message"
            [isLoading] = "isLoading"
        />
        
        <app-pagination
        (onUpdatePage)="updatePage($event)"
        [total_page]="total_page"
        [current_page]="current_page"/>

    </div>

</div>


<app-message-modal/>